import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fa from 'vuetify/lib/locale/fa'


Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { fa },
        current: 'fa',
    },
    rtl: true,
    theme: {
        themes: {
            light: {
                primary: '#8057EF',
                secondary: '#C4F8EF',
                forth:'#17E5A7',
                third: '#F5F6FD',
                error: '#b71c1c',
            },
        },
    },
});
